import { AGENT_FUNNEL_UNITY_NOTICE_SOURCE, AGENT_FUNNEL_UNITY_NOTICE_SOURCE_LABEL, AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE, AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE_LABEL, } from '@/entities/funnel-heatmap';
export const dealSourceLabel = (sourceKey) => {
    if (sourceKey === AGENT_FUNNEL_UNITY_NOTICE_SOURCE) {
        return AGENT_FUNNEL_UNITY_NOTICE_SOURCE_LABEL;
    }
    if (sourceKey === AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE) {
        return AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE_LABEL;
    }
    return sourceKey;
};
